import { __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
/**
 * Client for making User Management Service API calls.
 */
var UserMgtSvcClientv3 = /** @class */ (function (_super) {
    __extends(UserMgtSvcClientv3, _super);
    function UserMgtSvcClientv3() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/usermgtsvc';
        _this.apiVersion = '3';
        _this.usersEndpoint = '/users';
        _this.meEndpoint = '/me';
        return _this;
    }
    /**
     * Returns the expected schema for the User Details response object.
     *
     * @returns schema in object format
     */
    UserMgtSvcClientv3.userDetailSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            properties: {
                resourceId: {
                    type: 'string',
                },
                idpId: {
                    type: 'string',
                },
                idpType: {
                    type: 'string',
                },
                idpTenantId: {
                    type: 'string',
                },
                email: {
                    type: 'object',
                    properties: {
                        value: { type: 'string' },
                        verified: { type: 'boolean' },
                    },
                },
                phoneNumber: {
                    type: 'object',
                    properties: {
                        value: { type: 'string' },
                        verified: { type: 'boolean' },
                    },
                },
                familyName: {
                    type: 'string',
                },
                givenName: {
                    type: 'string',
                },
                userName: {
                    type: 'string',
                },
                locale: {
                    type: 'string',
                },
                createdAt: {
                    type: 'string',
                },
                updatedAt: {
                    type: 'string',
                },
            },
        };
    };
    /**
     *
     *Get user details by idp id and idp type
     *
     * @returns Axios response object
     * */
    UserMgtSvcClientv3.prototype.getUserDetails = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.usersEndpoint, ":idp"),
                        validationSchema: UserMgtSvcClientv3.userDetailSchema(),
                        params: {
                            idpType: options.idpType,
                            idpId: options.idpId,
                            idpTenantId: options.idpTenantId,
                        },
                    })];
            });
        });
    };
    /**
     *Get current active user details
     *
     * @returns Axios response object
     * */
    UserMgtSvcClientv3.prototype.getCurrentActiveUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.usersEndpoint).concat(this.meEndpoint),
                        validationSchema: UserMgtSvcClientv3.userDetailSchema(),
                    })];
            });
        });
    };
    /**
     *
     * Remove user details by ResourceId
     * @param {string} resourceId of the user
     * @returns Axios response object
     * */
    UserMgtSvcClientv3.prototype.deleteUser = function (resourceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.delete({
                        url: "".concat(this.usersEndpoint, "/").concat(resourceId),
                    })];
            });
        });
    };
    /**
     *
     * Get users details
     * @returns Axios response object
     * */
    UserMgtSvcClientv3.prototype.getUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.usersEndpoint),
                    })];
            });
        });
    };
    return UserMgtSvcClientv3;
}(StratusClient));
export { UserMgtSvcClientv3 };
var UserMgtSvcClient = /** @class */ (function (_super) {
    __extends(UserMgtSvcClient, _super);
    function UserMgtSvcClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/usermgtsvc';
        _this.apiVersion = '2';
        _this.usersEndpoint = '/users';
        _this.rolesEndpoint = '/roles';
        _this.meEndpoint = '/me';
        return _this;
    }
    /**
     * Returns the expected schema for the User list response object.
     *
     * @returns schema in object format
     */
    UserMgtSvcClient.userListSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['totalCount', 'resourceList'],
            additionalProperties: true,
            properties: {
                totalCount: {
                    type: 'number',
                },
                resourceList: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: ['resourceId', 'tenantResourceId', 'email', 'state'],
                        additionalProperties: true,
                        properties: {
                            resourceId: {
                                type: 'string',
                            },
                            tenantResourceId: {
                                type: 'string',
                            },
                            email: {
                                type: 'string',
                            },
                            state: {
                                type: 'string',
                            },
                            role: {
                                type: 'object',
                            },
                        },
                    },
                },
            },
        };
    };
    /**
     * Get a Users list on behalf of the authenticated user.
     *
     * @param {GetUserListOptions} options options for getting userlists
     * @returns Axios response object
     */
    UserMgtSvcClient.prototype.getUserList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: this.usersEndpoint,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-HTTP-Method-Override': 'GET',
                        },
                        data: this.parseOptions(options),
                        validationSchema: UserMgtSvcClient.userListSchema(),
                    })];
            });
        });
    };
    /**
     * Get a Users list on behalf of the authenticated user based on role name.
     *
     * @returns Axios response object
     */
    UserMgtSvcClient.prototype.getUsersByCategoryRole = function (tenantResourceId, roleName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.usersEndpoint, ":role?tenantResourceId=").concat(tenantResourceId, "&roleName=").concat(roleName),
                        validationSchema: UserMgtSvcClient.userListSchema(),
                    })];
            });
        });
    };
    UserMgtSvcClient.prototype.parseOptions = function (options) {
        var data = {
            startIndex: options.startIndex,
            maxResultSetSize: options.maxResultSetSize,
            orderList: {
                order: {
                    propertyName: options.orderByProperty,
                    ascending: options.orderByAscending,
                },
            },
            criterionList: options.criterionList,
        };
        return data;
    };
    /**
     * Returns the expected schema for the find User response object.
     *
     * @returns schema in object format
     */
    UserMgtSvcClient.getCurrentActiveUserSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['resourceId', 'email', 'familyName', 'givenName', 'locale'],
            additionalProperties: true,
            properties: {
                resourceId: {
                    type: 'string',
                },
                email: {
                    type: 'string',
                },
                familyName: {
                    type: 'string',
                },
                givenName: {
                    type: 'string',
                },
                locale: {
                    type: 'string',
                },
                phoneNumber: {
                    type: 'string',
                },
            },
        };
    };
    /**
     * Get currently active user information.
     *
     * @returns Axios response object
     */
    UserMgtSvcClient.prototype.getCurrentActiveUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "".concat(this.usersEndpoint).concat(this.meEndpoint),
                        validationSchema: UserMgtSvcClient.getCurrentActiveUserSchema(),
                    })];
            });
        });
    };
    /**
     * Returns the expected schema for the update user response object.
     *
     * @returns schema in object format
     */
    UserMgtSvcClient.updateUserSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: [
                'resourceId',
                'tenantResourceId',
                'email',
                'familyName',
                'givenName',
                'locale',
                'email',
            ],
            additionalProperties: true,
            properties: {
                resourceId: {
                    type: 'string',
                },
                tenantResourceId: {
                    type: 'string',
                },
                email: {
                    type: 'string',
                },
                familyName: {
                    type: 'string',
                },
                givenName: {
                    type: 'string',
                },
                locale: {
                    type: 'string',
                },
                phoneNumber: {
                    type: 'string',
                },
            },
        };
    };
    /**
     * Update user information.
     *
     * @param {string} userId user's resource id
     * @param {User} user users information
     * @returns Axios response object
     */
    UserMgtSvcClient.prototype.updateUser = function (userId, user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.put({
                        url: "".concat(this.usersEndpoint, "/").concat(userId),
                        data: this._updateUserData(user),
                        validationSchema: UserMgtSvcClient.updateUserSchema(),
                    })];
            });
        });
    };
    UserMgtSvcClient.prototype._updateUserData = function (user) {
        var data = {
            familyName: user.familyName,
            givenName: user.givenName,
            locale: user.locale,
            email: user.email,
            phoneNumber: user.phoneNumber,
        };
        return data;
    };
    /**
     * Returns the expected schema for the User list response object.
     *
     * @returns schema in object format
     */
    UserMgtSvcClient.rolesSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['totalCount', 'resourceList'],
            additionalProperties: true,
            properties: {
                totalCount: {
                    type: 'number',
                },
                resourceList: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: ['resourceId', 'tenantResourceId', 'displayName'],
                        additionalProperties: true,
                        properties: {
                            resourceId: {
                                type: 'string',
                            },
                            tenantResourceId: {
                                type: 'string',
                            },
                            displayName: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
        };
    };
    /**
     * get roles information.
     *
     * @returns Axios response object
     */
    UserMgtSvcClient.prototype.getRoles = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: this.rolesEndpoint,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-HTTP-Method-Override': 'GET',
                        },
                        data: this.parseOptions(options),
                        validationSchema: UserMgtSvcClient.rolesSchema(),
                    })];
            });
        });
    };
    return UserMgtSvcClient;
}(StratusClient));
export { UserMgtSvcClient };
//# sourceMappingURL=user-mgt-svc.js.map